import { useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { download, errMsg, fmtTime } from "@/lib/api";
import { PageHeader } from "@/components/opl/Common";
import { useList, DataTable, GhostBtn } from "@/components/opl/Crud";
import { Input } from "@/components/ui/input";

export default function AuditLogs() {
  const [q, setQ] = useState("");
  const [rows] = useList(`/audit-logs?action=${encodeURIComponent(q)}`);
  return (
    <div>
      <PageHeader title="Audit Logs" crumbs={["Audit"]}>
        {["csv", "xlsx"].map((f) => <GhostBtn key={f} testid={`export-audit-${f}`} onClick={() => download(`/audit-logs/export?fmt=${f}`, `opl_audit.${f}`).catch((e) => toast.error(errMsg(e)))}><Download className="h-4 w-4" />{f.toUpperCase()}</GhostBtn>)}
      </PageHeader>
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter by action (e.g. player.sold, bid.undo, config)" className="max-w-md mb-4" data-testid="audit-filter-input" />
      <DataTable rows={rows} testid="audit-table" columns={[
        { key: "t", label: "Time", render: (r) => <span className="text-xs text-slate-400 whitespace-nowrap">{fmtTime(r.created_at)}</span> },
        { key: "user_name", label: "User", render: (r) => <div><b>{r.user_name}</b><div className="text-[10px] text-slate-500">{r.user_role}</div></div> },
        { key: "action", label: "Action", render: (r) => <span className="num text-xs text-[#F5D061]">{r.action}</span> },
        { key: "entity", label: "Entity" }, { key: "reason", label: "Reason", render: (r) => r.reason || "—" },
        { key: "details", label: "Details", render: (r) => <span className="text-[11px] text-slate-400 line-clamp-2 max-w-md block">{JSON.stringify(r.details)}</span> },
      ]} />
    </div>
  );
}
